import { Injector } from '@sensenet/client-utils';
import { createContext } from 'react';

/**
 * Context that returns an Injector instance
 */
export const InjectorContext = /*#__PURE__*/createContext(new Injector());
InjectorContext.displayName = 'InjectorContext';
//# sourceMappingURL=injector.js.map